import React, { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useGlobalContext } from '@context';
import ResourcesLogo from '@assets/img/ResourcesIcon.png';
import PDFIcon from '@assets/img/PDFIcon.png';
import FileIcon from '@assets/img/FileIcon.png';
import './styles.scss';

const ResourcesPage: FC = () => {
  const {
    agencyName,
    facility: { locationFiles },
  } = useGlobalContext();

  const { state } = useLocation();
  const navigate = useNavigate();

  const resourceName = (state as any)?.resource as string;

  useEffect(() => {
    if (!resourceName) {
      navigate('/');
    }
  }, [resourceName, navigate]);

  const resources = locationFiles[resourceName as keyof typeof locationFiles];

  return (
    <section className="hbh-main-menu-container">
      <div className="hbh-menu-panel">
        <div className="hbh-menu-panel-header">
          <div className="logo">
            <img src={ResourcesLogo} alt="logo" />
          </div>
          <h2 className="title">
            <span className="capitalized">{resourceName}</span> | {agencyName}
          </h2>
        </div>
        <div className="hbh-menu-panel-content">
          {resources?.length ? (
            resources.map((resource) => {
              const resourceLink = resource.file ?? resource.link;

              return (
                <div className="resource" key={resourceLink.split('/').pop()}>
                  <img
                    className="icon"
                    src={resourceLink.includes('.pdf') ? PDFIcon : FileIcon}
                    alt="resource"
                  />
                  <div className="description">
                    <a href={resourceLink} rel="noreferrer" target="_blank">
                      {resource.description}
                    </a>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="resource-empty">
              No <span className="capitalized">{resourceName}</span> yet
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ResourcesPage;
